import React from 'react';
import Tabs from '@/Framework/UI/Pages/Landing/Sections/Tabs';
import SectionHeader from '@/Framework/UI/Pages/Landing/Sections/SectionHeader';
import Section from '@/Framework/UI/Pages/Landing/Sections/Section';
import { featuresTabsList } from '../tabs';
import SectionContainer from '@/Framework/UI/Pages/Landing/Sections/SectionContainer';

const FeaturesList = () => (
  <Section padding="top">
    <SectionContainer size="large">
      <SectionHeader
        title="Key features"
        description="ResearchRoom provides everything you need for seamless, simplified pre-deal research distribution while complying with the latest regulatory requirements."
        maxWidth={ 800 }
      />
    </SectionContainer>
    <SectionContainer size="large" narrow>
      <Tabs tabsList={ featuresTabsList } autoplay />
    </SectionContainer>
  </Section>
);

export default FeaturesList;
